<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <!-- <img
            src="img/avatars/6.jpg"
            class="c-avatar-img "
          /> -->
          <img v-if="filepath != null" :src="filepath" height="30px"/>
          <img v-else src="img/avatars/6.jpg" height="30px"/>
        </div>
      </CHeaderNavLink>
    </template>
   
    
  
    <CDropdownItem
          to="Setting"
          >My Profile</CDropdownItem
        >
        <CDropdownItem
          @click="SignOut()"
          >Log Out</CDropdownItem
        >
  </CDropdown>
</template>



<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>


     
<script>
export default {
    name: "TheHeader",
    data() {
        return {
            Name: "",
            filepath: "",
            itemsCount: 42
        };
    },
    async mounted() {

        this.GetInfoUser();

    },
    methods: {

        // async GetInfoUser() {
        //     try {
        //         const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
        //         if (response.status === 200 && response.data) {
        //             this.user = response.data;
        //             this.Name = this.user.name;
        //             this.filepath = this.user.filePath;
        //         } else {
        //             console.error("User info retrieval failed:", response.data.detail);
        //         }
        //     } catch (error) {
        //         console.error("Error fetching user info:", error);
        //     }
        // },
        // GoToLogin() {
        //     this.$router.push("/LogIn");
        // },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.$router.push("/Login");
                    }
                });
        },
    },
};
</script>
      

<style scoped>

</style>
  
  
  